import { useEffect, useState } from "react";
import { fetchCities, downloadCitiesExcel } from "../Api/ViewCities";
import { Container, Table, Button } from "react-bootstrap";
import { toast } from "react-toastify";
import moment from "moment";

const ViewCities = () => {
  const [cities, setCities] = useState([]);
  const [isDownloading, setIsDownloading] = useState(false);

  useEffect(() => {
    const loadCities = async () => {
      try {
        const data = await fetchCities();
        setCities(data || []);
      } catch (error) {
        toast.error(`🦄 Error Fetching Cities`);
      }
    };

    loadCities();
  }, []);

  const handleDownload = async () => {
    setIsDownloading(true);
    try {
      const response = await downloadCitiesExcel();
      
      if (!response.data) {
        throw new Error("No data received from server");
      }
      
      // Create download link
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'Cities_Data.xlsx');
      
      // Trigger download
      document.body.appendChild(link);
      link.click();
      
      // Cleanup
      setTimeout(() => {
        window.URL.revokeObjectURL(url);
        link.parentNode.removeChild(link);
      }, 100);
      
      toast.success("Cities data download started!");
    } catch (error) {
      console.error("Download error:", error);
      toast.error(`🦄 Download failed: ${error.message}`);
    } finally {
      setIsDownloading(false);
    }
  };

  return (
    <>
      
        <div className="main-content expand">
          <Container fluid className="list-container">
            <div className="d-flex justify-content-between align-items-center mb-3">
              <h2 className="list-title">View Cities</h2>
              <Button className="generate-btn"
                variant="primary" 
                onClick={handleDownload}
                disabled={isDownloading || cities.length === 0}
              >
                {isDownloading ? 'Downloading...' : 'Download Data'}
              </Button>
            </div>

            {cities.length > 0 ? (
              <Table bordered hover responsive className="data-table">
                <thead>
                  <tr>
                    <th>#</th>
                    <th>City ID</th>
                    <th>Code</th>
                    <th>Description</th>
                    <th>Country</th>
                    <th>Region</th>
                    <th>District</th>
                    <th>Tehsil</th>
                    <th>Created On</th>
                    <th>Created By</th>
                    <th>Changed On</th>
                    <th>Changed By</th>
                  </tr>
                </thead>
                <tbody>
                  {cities.map((city, index) => (
                    <tr key={index}>
                      <td>{index + 1}</td>
                      <td>{city.city_ID}</td>
                      <td>{city.code}</td>
                      <td>{city.description}</td>
                      <td>{city.country}</td>
                      <td>{city.region}</td>
                      <td>{city.district}</td>
                      <td>{city.tehsil}</td>
                      <td>
                        {moment(city.createdOnDate).format('L')} at {city.createdOnTime?.substring(0, 8)}
                      </td>
                      <td>{city.createdBy}</td>
                      <td>
                        {city.changedOnDate ? 
                          `${moment(city.changedOnDate).format('L')} at ${city.changedOnTime?.substring(0, 8)}` 
                          : 'N/A'}
                      </td>
                      <td>{city.changedBy || 'N/A'}</td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            ) : (
              <p className="no-data">No cities found.</p>
            )}
          </Container>
        </div>
      
    </>
  );
};

export default ViewCities;